import axios from "axios";
import Auth from "@aws-amplify/auth";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_PMB_BASE_URL}`,
});

API.interceptors.request.use(
  async (config) => {
    const session = await Auth.currentSession();
    const token = session.getIdToken();
    config.headers = {
      Authorization: `Bearer ${token.getJwtToken()}`,
      Accept: "application/json",
      "Content-Type": "application/json",
      // "X-Frame-Options":"SAMEORIGIN",
      // "Strict-Transport-Security":"max-age=31536000; includeSubDomains",
      // "Permissions-Policy":"fullscreen=(), geolocation=()",
      // "X-Content-Type-Options":"nosniff",
      // "Referrer-Policy":"no-referrer"
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
